// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyAnnouncementSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.685 13.77c.895.19 2.693.603 3.994 1.022.154.05.308.1.462.153l.998 3.722a1 1 0 0 1-.707 1.225L8.5 20.41a1 1 0 0 1-1.225-.707l-1.59-5.933zm4.224.308a17.668 17.668 0 0 0-.159-.05V5.924c1.573-.513 3.19-1.162 5.354-2.084a1.006 1.006 0 0 1 1.255.405.98.98 0 0 1 .141.514v10.463a1.006 1.006 0 0 1-1.416.912c-2.037-.917-3.618-1.555-5.175-2.056zM3.331 7.435c1.973-.345 3.493-.665 4.919-1.06V13.605a55.836 55.836 0 0 0-2.782-.645c-.66-.13-1.366-.26-2.137-.394a1.002 1.002 0 0 1-.831-.987V8.422c0-.49.354-.903.83-.987zM18.13 5.518a.5.5 0 0 1 .353-.612l2.898-.777a.5.5 0 0 1 .612.354l.259.966a.5.5 0 0 1-.354.612l-2.897.777a.5.5 0 0 1-.613-.354zM22.69 9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-4.302 4.483a.5.5 0 0 1 .613-.354l2.897.777a.5.5 0 0 1 .354.612l-.259.966a.5.5 0 0 1-.612.354l-2.898-.777a.5.5 0 0 1-.354-.612z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyAnnouncementSolid;
